<template>
  <div class="pay-ok">
    <div class="pay-ok-form">
      <img class="ok-img" src="../../assets/lose.png" alt>
      <p class="ok-tip">支付失败，请重新购买</p>
      <button class="login-btn" @click="repay">重新购买</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pay-lose',
  data() {
    return {}
  },
  methods: {
    repay() {
      this.$router.push({ path: '/pay/' })
    }
  }
}
</script>
<style lang="less" scoped>
.pay-ok {
  margin-top: 24px;
  .ok-img {
    width: 236px;
  }
  .ok-tip {
    margin-top: 27px;
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #2c5ac8;
  }
  .login-btn {
    width: 261px;
    height: 38px;
    background: #2c5ac8;
    border-radius: 8px;
    color: #ffffff;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
